type Line = { key: string; positions: string[] };

/** Goalkeepers do not inherit the field players' substitution rhythm. */
export const lineRhythm = (line: Line | undefined, rhythms: Record<string, string>, shared: string | number): string => {
  if (!line) return String(shared);
  if (rhythms[line.key] !== undefined) return rhythms[line.key];
  const keeperKeys = new Set(['goal', 'goalkeeper', 'keeper', 'gk']);
  const keeper = keeperKeys.has(line.key.toLowerCase()) ||
    (line.positions.length > 0 && line.positions.every(key => keeperKeys.has(key.toLowerCase())));
  return keeper ? '0' : String(shared);
};

/** A fixed keeper adds no timing boundaries to an otherwise uniform grid. */
export const hasVariableLineRhythms = (lines: Line[], strategy?: { level: string; rhythm: string; rhythms: Record<string, string> } | null): boolean => {
  if (strategy?.level !== 'advanced') return false;
  const counts = lines.filter(line => !(lineRhythm(line, {}, 1) === '0' && Number(lineRhythm(line, strategy.rhythms, strategy.rhythm)) === 0))
    .map(line => Number(lineRhythm(line, strategy.rhythms, strategy.rhythm)));
  return new Set(counts).size > 1;
};
